import { Component, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';

@Component({
    selector: 'electronic-signature',
    templateUrl: './electronic-signature.component.html',
    styleUrls: ['./electronic-signature.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class ElectronicSignatureComponent {
  options: FormControlOption[] = [
    {
      value: 'conditionGeneralUtilisationAccepte',
      label:
        'J’ai lu et j’accepte les Conditions Générales d’Utilisation du site.',
      suffix: { title: 'A' },
      consulter: 'https://www.euodia.fr/upload/files/Euodia-CGU.pdf',
    },
    {
      value: 'termesDuContratAccepte',
      label:
        'J’ai reçu reçu et pris connaissance des Conditions Générales du contrat et des caractéristiques principales des supports sélectionnés (Annexe financière des Conditions Générales, prospectus et notices d’information des supports).',
      suffix: { title: 'B' },
    },
    {
      value: 'variationDeValeurAChargeAccepte',
      label:
        'Je déclare avoir été clairement informé que je prends à ma charge les variations de valeurs des supports que j’ai souscrits.',
      suffix: { title: 'C' },
    },
    {
      value: 'exactitudeDesInformationsAccepte',
      label: 'J’atteste l’exactitude des informations fournies.',
      suffix: { title: 'D' },
    },
    {
      value: 'politiqueDeProtectionDesDonneesAccepte',
      label:
        "J’ai lu et accepte la Politique de Protection des Données Personnelles d'Euodia.",
      suffix: { title: 'E' },
      consulter: 'https://www.euodia.fr/rgpd/',
    },
  ];
}
